import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomRadioButtonComponent} from './custom-radio-button.component';

@NgModule({
  declarations: [CustomRadioButtonComponent],
  exports: [
    CustomRadioButtonComponent
  ],
  imports: [
    CommonModule
  ]
})
export class CustomRadioButtonModule {}
